// ==========================================================================
// Central location for defining carousels
// ==========================================================================

import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';

// helper function
function init(selector, options) {
  if (!document.querySelector(selector)) return;

  const slider = document.querySelector(selector);
  const slides = options.cellSelector
    ? slider.querySelectorAll(options.cellSelector)
    : slider.children;

  if (slides.length > 1) {
    return new Flickity(selector, options);
  }
}

export function cardCarousel(selector, selectorCell='.card-carousel-cell') {
  return init(selector, {
    autoPlay: 6000,
    contain: true,
    pageDots: false,
    setGallerySize: false,
    cellSelector: selectorCell, // Needed because of heading over the carousel
    bgLazyLoad: 2,
    watchCSS: true,
  });
}

export function fsGalleryCarousel() {
  return [
    init('.js-carousel-gallery', {
      setGallerySize: false,
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      lazyLoad: 2,
    }),
    init('.js-carousel-gallery-nav', {
      asNavFor: '.js-carousel-gallery',
      setGallerySize: false,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      lazyLoad: 8,
    }),
  ];
}

export function windowGalleryCarousel() {
  return [init('.js-carousel-gallery', {
    setGallerySize: false,
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    lazyLoad: 2,
  }),

  init('.js-carousel-gallery-nav', {
    asNavFor: '.js-carousel-gallery',
    setGallerySize: false,
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    lazyLoad: 8,
  })];
}


// WEBPACK FOOTER //
// ./src/js/carousels.js